import {createBugsnagClient} from '@shopify/react-bugsnag';

export const API_KEY = 'b812baf50b5a2a037af66413027230ed';

export const client = createBugsnagClient({
  apiKey: API_KEY,
  appType: 'hydrogen',
  appVersion: window.VERSION || 'development',
  onError: (bugsnagEvent) => {
    if (typeof globalThis === 'undefined' || !window.IntersectionObserver) {
      return false;
    }
    const error = bugsnagEvent.originalError;
    // Cautiously report errors of unexepected shape
    if (!error || !(error instanceof Error) || !error.stack) {
      return true;
    }

    const domainsAllowList = [document.location.host, 'cdn.shopify.com'];
    return domainsAllowList.some((domain) => error.stack?.includes(domain));
  },
});
